import React, { useEffect, useState } from "react";
import {
  Button,
  Group,
  Modal,
  Select,
  SimpleGrid,
  Text,
  createStyles,
} from "@mantine/core";

import { useSelector } from "react-redux";
import { renameFile } from "../../services/Document";

const useStyles = createStyles((theme) => ({
  myfont: {
    fontFamily: "Inter",
    overflow: "visible",
  },
  mwd: {
    width: "100%",
  },
}));

const findFolderPath = (list, folderId) => {
  for (const folder of list || []) {
    const id = folder?._id || folder?.id;
    if (id === folderId) return [folder];
    if (folder?.folders?.length) {
      const nested = findFolderPath(folder.folders, folderId);
      if (nested) return [folder, ...nested];
    }
  }
  return null;
};

const StaffMoveFileModal = ({ opened, onclose, title, data, userId, userType, currentFolderId }) => {
  const { classes } = useStyles();
  const { renameFileLoading, folders } = useSelector((state) => state.document);

  // path is the array of currently selected folders, one per level
  const [path, setPath] = useState([]);
  const [currentLocationPath, setCurrentLocationPath] = useState([]);

  useEffect(() => {
    if (opened) {
      const currentFolderId = data?.folder?._id || data?.folder?.id || null;
      const existingPath = currentFolderId
        ? findFolderPath(folders, currentFolderId) ||
          [{ _id: currentFolderId, name: data?.folder?.name }]
        : null;
      setPath(existingPath || []);
      setCurrentLocationPath(existingPath || []);
    }
  }, [opened]);

  const toOption = (f) => ({ value: f?._id || f?.id, label: f?.name });

  const levels = [folders || []];
  path.forEach((folder) => {
    if (folder?.folders?.length) {
      levels.push(folder.folders);
    }
  });

  const handleSelectAtLevel = (levelIndex, folderId) => {
    const levelList = levels[levelIndex];
    const chosen = levelList?.find((f) => (f?._id || f?.id) === folderId);
    const newPath = path.slice(0, levelIndex);
    if (chosen) newPath.push(chosen);
    setPath(newPath);
  };

  const selectedFolder = path[path.length - 1] || null;

  const resetForm = () => {
    setPath([]);
    onclose();
  };

  const onSave = async () => {
    try {
      if (data) {
        let payload = {
          name: data?.name,
          folder: (selectedFolder?._id || selectedFolder?.id) || null,
          file: data?.id,
        };
        await renameFile(payload, currentFolderId, userId, userType);
      }
      resetForm();
    } catch (error) {
      console.error("Error moving file:", error.message);
    }
  };

  return (
    <div key={data?._id} style={{ overflowX: "auto" }}>
      <div style={{ minWidth: "600px" }}>
        <Modal
          opened={opened}
          size={"xl"}
          onClose={() => {
            onclose();
          }}
          shadow="sm"
          radius={"lg"}
          zIndex={1000}
          title={
            <Group>
              <img src="/assets/images/addfac.png" alt="" />
              <Text sx={{ fontFamily: "Inter", fontSize: 22, fontWeight: 600 }}>
                {title}
              </Text>
            </Group>
          }
          centered
        >
          <Text size="sm" mb={10} color="dimmed">
            Currently in:{" "}
            <Text span fw={600} c="dark">
              {currentLocationPath?.length
                ? `All Documents > ${currentLocationPath.map((f) => f?.name).join(" > ")}`
                : "All Documents"}
            </Text>
          </Text>
          <SimpleGrid
            cols={1}
            className={classes.mwd}
            sx={{
              marginTop: 10,
              paddingBottom: 30,
            }}
          >
            <Select
              className={classes.myfont}
              label="Folder"
              size="md"
              placeholder="All Documents"
              data={levels[0].map(toOption)}
              value={path[0] ? path[0]._id || path[0].id : null}
              onChange={(val) => handleSelectAtLevel(0, val)}
              clearable
            />
            {path.map((folder, idx) => {
              const children = folder?.folders || [];
              if (!children.length) return null;
              const nextSelected = path[idx + 1];
              return (
                <Select
                  key={folder?._id || folder?.id}
                  className={classes.myfont}
                  label={`Subfolder of "${folder?.name}"`}
                  size="md"
                  placeholder="Select a subfolder (optional)"
                  data={children.map(toOption)}
                  value={nextSelected ? nextSelected._id || nextSelected.id : null}
                  onChange={(val) => handleSelectAtLevel(idx + 1, val)}
                  clearable
                />
              );
            })}
          </SimpleGrid>

          <Text size="xs" color="dimmed" mb={10}>
            {selectedFolder
              ? `File will be moved to "${selectedFolder?.name}"`
              : "File will be moved to All Documents (no folder)"}
          </Text>

          <Button
            color="yellow"
            sx={{ marginRight: "auto", width: 122, fontFamily: "Inter" }}
            onClick={onSave}
            loading={renameFileLoading}
          >
            Move
          </Button>
        </Modal>
      </div>
    </div>
  );
};

export default StaffMoveFileModal;
